/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    var fetch = MoyaContainer.get('core.fetch');
    var util = MoyaContainer.get('core.util');
    MoyaComponents.register('site.employees', function (el) {
        el.querySelectorAll('.filter__container button').forEach(function (button) {
            button.addEventListener('click', function () {
                //Update button active class
                el.querySelectorAll('.filter__container button').forEach(function (btn) {
                    btn.classList.remove('active');
                });
                button.classList.add('active');
                //Filter containers
                el.classList.add('isFiltering');
                setTimeout(function () {
                    el.querySelectorAll('.cards__container__employees').forEach(function (container) {
                        if (container.getAttribute('data-filter-codename') === button.getAttribute('data-codename')) {
                            container.classList.add('active');
                        }
                        else {
                            container.classList.remove('active');
                        }
                    });
                    el.classList.remove('isFiltering');
                }, 400);
            });
        });
        var singleView = el.querySelector('.employee__single__view');
        util.delegate(document.body, 'click', 'button.employeeOpen', function (e) {
            fetch.fetchJson(e.target.getAttribute('data-href')).then(function (response) {
                if (response.html) {
                    singleView.innerHTML = response.html;
                    setTimeout(function () {
                        document.body.classList.add('employee-open');
                    }, 50);
                }
            });
        });
        util.delegate(singleView, 'click', '.card__employee__detail__inner', function (e) {
            if (!e.target.classList.contains('employeeClose')) {
                e.stopPropagation();
            }
        });
        util.delegate(document.body, 'click', 'body', function () {
            if (document.body.classList.contains('employee-open')) {
                document.body.classList.remove('employee-open');
                setTimeout(function () {
                    singleView.innerHTML = '';
                }, 400);
            }
        });
    });

}());
typeof tsBuild === 'function' && tsBuild();})();
